<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 18:52:49
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-09-30 11:17:09
-->
<template>
  <div class="paper-add">
    <div class="form-title">添加考试试卷</div>
    <el-form ref="paperForm" class="paperForm" :model="form" :rules="rules" label-width="140px">
      <el-form-item label="考试试卷名称：" prop="paperTitle">
        <el-input v-model="form.paperTitle" placeholder="请输入考试试卷名称"></el-input>
      </el-form-item>
      <el-form-item label="适用类型：" prop="paperType">
        <el-select v-model="form.paperType" placeholder="请选择类型">
          <el-option label="实操" :value="1"></el-option>
          <el-option label="理论" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="适用职业/等级：" prop="job">
        <el-cascader
          v-model="form.job"
          placeholder="请选择职业/等级"
          :options="jobLevelList"
          :props="{
            value: 'id',
            label: 'jobName',
            children: 'levelList',
          }"
          @change="handleJobLevelChange"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="适用工种：" prop="workTypeId">
        <el-select v-model="form.workTypeId" placeholder="请选择工种">
          <el-option
            v-for="item in workTypeList"
            :key="item.id"
            :label="item.workTypeName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="描述：" prop="description">
        <el-input
          v-model="form.description"
          type="textarea"
          :rows="4"
          maxlength="255"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  examPaperCreate,
  filterJobLevel,
  filterWorkType,
  examPaperDetail,
  examPaperEdit,
} from '@/api/exam'
import to from 'await-to'
export default {
  name: 'PaperAdd',
  data() {
    return {
      form: {
        workTypeId: '',
      },
      rules: {
        paperTitle: [{ required: true, message: '请输入考试试卷名称', trigger: 'blur' }],
        job: [{ required: true, message: '请选择职业/等级', trigger: 'change' }],
        paperType: [{ required: true, message: '请选择适用类型', trigger: 'change' }],
        examStartTime: [{ required: true, message: '请选择考试时间', trigger: 'change' }],
      },
      jobLevelList: [],
      workTypeList: [],
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getExamPaper()
    }
    this.getJobLevelList()
  },
  methods: {
    async getExamPaper() {
      const [res, err] = await to(examPaperDetail({ id: this.$route.params.id }))
      if (err) return this.$message.warning(err.msg)
      this.form = res.data
      this.form.job = [res.data.jobId + '', res.data.jobLevel]
      if (this.form.jobId) {
        this.getWorkTypeList()
      }
    },
    async getJobLevelList() {
      const [res, err] = await to(filterJobLevel({}))
      if (err) return this.$message.warning(err.msg)
      this.jobLevelList = res.data
    },
    async getWorkTypeList() {
      const [res, err] = await to(filterWorkType({ jobId: this.form.jobId }))
      if (err) return this.$message.warning(err.msg)
      this.workTypeList = res.data
    },
    handleJobLevelChange() {
      this.form.jobId = this.form.job[0]
      this.form.jobLevel = this.form.job[1]
      this.form.workTypeId = ''
      this.getWorkTypeList()
    },
    submit() {
      if (this.$route.params.id) {
        this.form.paperId = this.$route.params.id
        this.update()
      } else {
        this.create()
      }
    },
    async create() {
      this.$refs.paperForm.validate(async valid => {
        if (valid) {
          const [, err] = await to(examPaperCreate(this.form))
          if (err) return this.$message.warning(err.msg)
          this.$message.success('添加成功')
          this.$router.push('/exam/paper')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async update() {
      this.$refs.paperForm.validate(async valid => {
        if (valid) {
          const [, err] = await to(examPaperEdit(this.form))
          if (err) return this.$message.warning(err.msg)
          this.$message.success('编辑成功')
          this.$router.push('/exam/paper')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.paper-add {
  background-color: #fff;
  height: 100%;
  .form-title {
    height: 72px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    padding: 0 20px;
    line-height: 72px;
    border-bottom: 1px solid #e8ebf2;
    margin-bottom: 30px;
  }
  /deep/.el-form-item {
    margin-bottom: 30px;
    .el-input,
    .el-select,
    .el-cascader,
    .el-textarea {
      width: 440px !important;
      .el-input__inner,
      .el-textarea__inner {
        border-radius: 2px;
      }
      input {
        height: 40px;
      }
    }
    .el-button {
      width: 100px;
      height: 40px;
      background: #3671bf;
      border-radius: 4px !important;
    }
  }
}
</style>
